<cwc-modal [open]="openDialog" [closeOnBdClick]="false" (cwcClose)="cwcCancel()">
  <h1 class="alert-title" arkik-dialog-title>
    <cwc-icon class="icon" color="bright-orange" hover-color="bright-orange-dark" name="warning"> </cwc-icon>
  </h1>

  <ng-container arkik-dialog-content>
    <div class="alert-content">
      {{ displayMessage }}
    </div>
    <div class="alert-instructions">
      <span *ngIf="type === 'warning'"> {{ 'views-plant-network-offline-instructions' | translation }} </span>
    </div>
  </ng-container>

  <footer slot="footer" arkik-dialog-actions>
    <ng-container *ngIf="actions && actions.length > 0; else defaultButtons">
      <cwc-button
        *ngFor="let action of actions"
        type="button"
        [variant]="action.variant || 'primary'"
        (click)="executeAction(action)"
      >
        {{ action?.description ? action?.description : (action.label | translation) }}
      </cwc-button>
    </ng-container>
  </footer>
</cwc-modal>

<ng-template #defaultButtons>
  <cwc-button type="button" variant="regular" (cwcClick)="cwcCancel()">
    {{ 'views.globals.close' | translation }}
  </cwc-button>
</ng-template>
